export const DELETE_SHOPS = "DELETE_SHOPS";
export const deleteShopsAction = (shops) => {
    return {
        type: "DELETE_SHOPS",
        payload: shops
    }
}

export const FETCH_SHOPS = "FETCH_SHOPS";
export const fetchShopsAction = (shops) => {
    return {
        type: "FETCH_SHOPS",
        payload: shops
    }
}

export const INIT_SHOPS = "INIT_SHOPS";
export const initShopsAction = () => {
    return {
        type: "INIT_SHOPS",
        payload: null
    }
}
